const closeAll = (except = null) => {
    for (const share of document.querySelectorAll('.account-share')) {
        if (share === except) {
            continue;
        }
        share.querySelector('.account-share-menu')?.setAttribute('hidden', '');
        share.querySelector('.account-share-toggle')?.setAttribute('aria-expanded', 'false');
        share.classList.remove('is-flipped');
        const feedback = share.querySelector('.account-share-feedback');
        if (feedback) {
            feedback.setAttribute('hidden', '');
            feedback.textContent = '';
        }
    }
};

const copyLink = async (url) => {
    try {
        await navigator.clipboard.writeText(url);
        return true;
    } catch (e) {
        const input = document.createElement('input');
        input.value = url;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        let copied = false;
        try {
            copied = document.execCommand('copy');
        } catch (err) {
            copied = false;
        }
        document.body.removeChild(input);
        return copied;
    }
};

const bind = (share) => {
    const url = share.dataset.shareUrl;
    const menu = share.querySelector('.account-share-menu');
    const toggle = share.querySelector('.account-share-toggle');
    const feedback = share.querySelector('.account-share-feedback');
    const nativeButton = share.querySelector('.account-share-native');

    if (!url || !menu || !toggle) {
        return;
    }

    const say = (message) => {
        if (!feedback) {
            return;
        }
        feedback.textContent = message;
        feedback.removeAttribute('hidden');
    };

    if (nativeButton && typeof navigator.share === 'function') {
        nativeButton.removeAttribute('hidden');
        nativeButton.addEventListener('click', async () => {
            try {
                await navigator.share({url});
            } catch (e) {
            }
        });
    }

    toggle.addEventListener('click', () => {
        const isOpen = !menu.hasAttribute('hidden');
        closeAll(share);
        if (isOpen) {
            menu.setAttribute('hidden', '');
            toggle.setAttribute('aria-expanded', 'false');
            return;
        }
        menu.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        // the list sits in a horizontally scrollable wrapper, which also clips
        // vertically, so on the last rows the menu has to grow upwards instead;
        // on the phone card layout the wrapper stops clipping and the viewport
        // is what runs out
        share.classList.remove('is-flipped');
        const wrapperBottom = share.closest('.account-table-wrapper')?.getBoundingClientRect().bottom
            ?? Infinity;
        const limit = Math.min(wrapperBottom, window.innerHeight);
        if (menu.getBoundingClientRect().bottom > limit) {
            share.classList.add('is-flipped');
        }
    });

    share.querySelector('.account-share-copy')?.addEventListener('click', async () => {
        if (await copyLink(url)) {
            say(feedback?.dataset.copied ?? '');
        }
    });

    share.querySelector('.account-share-instagram')?.addEventListener('click', async () => {
        const copied = await copyLink(url);
        if (copied) {
            say(feedback?.dataset.instagram ?? '');
        }
        window.open('https://www.instagram.com/', '_blank', 'noopener');
    });
};

document.addEventListener('DOMContentLoaded', () => {
    const shares = document.querySelectorAll('.account-share');
    if (!shares.length) {
        return;
    }

    for (const share of shares) {
        bind(share);
    }

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.account-share')) {
            closeAll();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeAll();
        }
    });
});
